angular
    .module('app')
    .component('gamesList', {
        templateUrl: '/templates/pages/games/gamesList/gamesList.html',
        controller: 'GamesListController',
        controllerAs: 'vm',
    });